import clsx from 'clsx';
import Button from 'components/atoms/Button/Button';
import Heading from 'components/atoms/Heading/Heading';
import Modal from 'components/atoms/Modal/Modal';
import { useTenant } from 'hooks/useTenant';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { SVGProps } from 'react';
import classes from './PaypalError.module.scss';
import PaypalErrorMessage from './PaypalErrorMessage';

export type Props = {
  className?: string;
  onClose: () => void;
};

export default function PaypalError({ className, onClose }: Props) {
  const { redemptionsError } = useRouter().query;
  const PaypalLogo = useTenant({
    mobiworkx: dynamic<SVGProps<SVGSVGElement>>(() => import('./assets/paypal-logo-narrow.svg')),
    qmee: dynamic<SVGProps<SVGSVGElement>>(() => import('./assets/paypal-logo-filled.svg')),
    lifepoints: dynamic<SVGProps<SVGSVGElement>>(() => import('./assets/paypal-logo-narrow.svg')),
  });

  return (
    <Modal
      buttons={
        <Button onClick={onClose} className={classes.closeButton}>
          Close
        </Button>
      }
      className={clsx(classes.root, className)}
      bodyClassName={classes.body}
      buttonsClassName={classes.buttons}
    >
      <PaypalLogo width={55} height={55} className={classes.paypalLogo} />
      <Heading level={2} className={classes.heading}>
        Something went wrong linking your Paypal account
      </Heading>
      <PaypalErrorMessage
        redemptionsError={redemptionsError as string}
        className={classes.errorMessage}
      />
    </Modal>
  );
}
